import { type CookieOptions } from 'ngx-cookie-service';

export const COOKIE_PREFIX = 'myre-lang';
export const cookieOptions: CookieOptions = {
  path: '/',
  secure: false,
};
